import type { FileRecord } from "./types";

type FileRecordUrlFields = Pick<
  FileRecord,
  "published" | "raw_url" | "view_url" | "published_url"
>;

/**
 * Raw bytes of a published file — what a program fetches or embeds, never a
 * link for people. Falls back to the deprecated `published_url` for servers
 * that still send only that.
 */
export function resolveFileRecordRawUrl(
  record: FileRecordUrlFields | undefined,
): string | undefined {
  if (!record?.published) return undefined;
  return record.raw_url || record.published_url || undefined;
}

/**
 * Public viewer page of a published file — the link to give a person.
 *
 * Servers that predate `view_url` send only the raw URL; the `/view` prefix
 * is injected here for them, and nowhere else. Delete the fallback once no
 * such server is deployed.
 */
export function resolveFileRecordViewUrl(
  record: FileRecordUrlFields | undefined,
): string | undefined {
  if (!record?.published) return undefined;
  if (record.view_url) return record.view_url;
  const raw = record.published_url;
  return raw ? raw.replace("/public/", "/view/public/") : undefined;
}
